<template>

  <form v-on:submit="save" action="#" method="post" id="" v-if="user">

    <div class="row">
      <div class="col-xs-7">
        <div class="form-group">
          <label for="role" class="required">Role</label>
          <v-select2 id="role" label="name" :options="roles" v-model="roleSelected"></v-select2>
        </div>
      </div>
      <div class="col-xs-5" style="margin-top: 20px">
        <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info pull-right" :data-style="submit.dataStyle"> Save Changes </vue-ladda>
      </div>
    </div>
  </form>
</template>

<style scoped>

</style>
<script>

import VueLadda from 'vue-ladda'
import vSelect2 from '../../components/utils/select2'

export default {
  components: {VueLadda, vSelect2},
  name: 'Role',
  props: ['user'],
  data () {
    return {
      roles: [],
      roleSelected: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.axios.patch('user/' + this.user.id + '/role', {
        role_id: this.roleSelected !== null ? this.roleSelected.id : null
      }).then((response) => {

        this.$notify({
          type: 'success',
          title: 'Role changed',
          placement: 'bottom-right'
        })
      }).catch((error) => {
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.axios.get('/user/' + this.user.id + '/roles')
        .then((response) => {
          this.roles = response.data
        })
        .catch(function (error) {
        })
    }
  },
  beforeMount () {
    if (this.user !== null && typeof this.user.roles !== 'undefined' && this.user.roles.length !== 0) {
      this.roleSelected = this.user.roles[0]
    }
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Role.vue